import { Component, computed, inject, signal } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { GenericRichTextDirective, getFieldValue } from '@core/jss-utils';
import { CrntButton } from '@essent/current-web-angular';
import { type OrderCrossSellFormValues } from '@innogy/become-a-customer/state';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { SetValueAction, type FormGroupState } from 'ngrx-forms';

@Component({
  selector: 'wl-cross-sell-loyalty-info-modal',
  templateUrl: './cross-sell-loyalty-info-modal.component.html',
  standalone: true,
  imports: [
    ModalComponent,
    ModalBodyDirective,
    AutomationIdDirective,
    GenericRichTextDirective,
    CrntButton,
    ToolTipComponent,
  ],
})
export class CrossSellLoyaltyInfoModalComponent {
  private readonly store = inject(Store);
  private readonly activeModal = inject(NgbActiveModal);

  readonly rendering = signal<InnogyComponentRendering | undefined>(undefined);
  readonly formState = signal<
    FormGroupState<OrderCrossSellFormValues> | undefined
  >(undefined);

  readonly content = computed(() => ({
    modalTitle: getFieldValue(this.rendering(), 'thuisvoordeelModalTitle', ''),
    modalContent: getFieldValue(
      this.rendering(),
      'thuisvoordeelModalContent',
      ''
    ),
    modalContentBottom: getFieldValue(
      this.rendering(),
      'thuisvoordeelModalContentBottom',
      ''
    ),
    primaryButtonText: getFieldValue(
      this.rendering(),
      'thuisvoordeelPrimaryButtonText',
      ''
    ),
    secondaryButtonText: getFieldValue(
      this.rendering(),
      'thuisvoordeelSecondaryButtonText',
      ''
    ),
  }));

  readonly usps = computed(() =>
    [...Array(5)]
      .map((_, i) => ({
        text: getFieldValue(
          this.rendering(),
          `thuisvoordeelModalUSP${i + 1}`,
          ''
        ),
        tooltip: getFieldValue(
          this.rendering(),
          `thuisvoordeelModalUSP${i + 1}Tooltip`,
          ''
        ),
      }))
      .filter((usp) => !!usp.text)
  );

  public closeModal() {
    this.activeModal.close();
  }

  public primaryAction() {
    const formState = this.formState();
    if (formState) {
      this.store.dispatch(
        new SetValueAction(
          formState.controls.hasSelectedLoyaltyProgram.id,
          true
        )
      );
    }
    this.closeModal();
  }

  public secondaryAction() {
    const formState = this.formState();
    if (formState) {
      this.store.dispatch(
        new SetValueAction(
          formState.controls.hasSelectedLoyaltyProgram.id,
          false
        )
      );
    }
    this.closeModal();
  }
}
